import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { Button, Modal, Text } from "@nextui-org/react";
import React, { useCallback, useRef, useState } from "react";
import { Icon } from "../../fa-icon";
import styles from "./shared-styles.module.less"; // import { TextField } from "./text-field"

// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-constraint
export var List = function List(_ref) {
  var allowAdd = _ref.allowAdd,
      display = _ref.display,
      editHeader = _ref.editHeader,
      individuallyEdit = _ref.individuallyEdit,
      input = _ref.input,
      inputProps = _ref.inputProps,
      newItem = _ref.newItem,
      onValueAdded = _ref.onValueAdded,
      onValueDeleted = _ref.onValueDeleted,
      onValueChanged = _ref.onValueChanged,
      onValuesChanged = _ref.onValuesChanged,
      values = _ref.values;
  var currentValuesRef = useRef(_toConsumableArray(values));
  var currentValues = currentValuesRef.current;

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      editing = _useState2[0],
      setEditing = _useState2[1];

  var triggerValuesChanged = useCallback(function () {
    if (!onValuesChanged) return;
    onValuesChanged(currentValues);
  }, [onValuesChanged, currentValues]);
  var updateValue = useCallback(function (index, newValue) {
    if (currentValues[index] === newValue) return;
    currentValues[index] = newValue;
    if (onValueChanged) onValueChanged(index, newValue, values[index]);
    triggerValuesChanged();
  }, [currentValues, onValueChanged, triggerValuesChanged, values]);
  var onAddNewItem = useCallback(function (e) {
    e.preventDefault();
    var index = currentValues.length;
    currentValues.push(newItem === null || newItem === void 0 ? void 0 : newItem());
    if (onValueAdded) onValueAdded(index, currentValues[index]);
    triggerValuesChanged();
    setEditing(index);
  }, [currentValues, newItem, onValueAdded, triggerValuesChanged]);
  var deleteItem = useCallback(function (index) {
    var deletedValues = currentValues.splice(index, 1);
    if (onValueDeleted) onValueDeleted(index, deletedValues[0]);
    triggerValuesChanged();
  }, [currentValues, onValueDeleted, triggerValuesChanged]);
  var onEditClick = useCallback(function (index) {
    setEditing(index);
  }, []);
  var onCancelEditClick = useCallback(function () {
    setEditing(undefined);
  }, []);

  if (individuallyEdit && editing !== undefined && currentValues !== null && currentValues !== void 0 && currentValues[editing]) {
    var Component = input;
    var currentValue = currentValues[editing];
    return /*#__PURE__*/React.createElement(Modal, {
      open: true,
      scroll: true,
      blur: true,
      onClose: onCancelEditClick,
      width: "80%"
    }, /*#__PURE__*/React.createElement(Modal.Header, null, editHeader ? editHeader({
      initialValue: currentValue
    }) : /*#__PURE__*/React.createElement(Text, null, "Editing entry")), /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement(Component, _extends({}, inputProps, {
      isEditing: true,
      initialValue: currentValue,
      fullWidth: true,
      onValueChanged: function onValueChanged(newValue) {
        updateValue(editing, newValue);
      }
    }))), /*#__PURE__*/React.createElement(Modal.Footer, null, /*#__PURE__*/React.createElement(Button, {
      icon: /*#__PURE__*/React.createElement(Icon, {
        name: "check"
      }),
      onClick: onCancelEditClick
    }, "Done")));
  }

  return /*#__PURE__*/React.createElement("ul", null, currentValues === null || currentValues === void 0 ? void 0 : currentValues.map(function (value, index) {
    var Component = individuallyEdit ? display !== null && display !== void 0 ? display : input : input;
    return /*#__PURE__*/React.createElement("li", {
      key: "item_".concat(index)
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.flex
    }, /*#__PURE__*/React.createElement(Component, _extends({}, inputProps, {
      initialValue: value,
      fullWidth: true,
      onValueChanged: function onValueChanged(newValue) {
        updateValue(index, newValue);
      }
    })), individuallyEdit && /*#__PURE__*/React.createElement(Button, {
      auto: true,
      css: {
        p: "0 4px",
        top: "8px"
      },
      size: "xs",
      light: true,
      icon: /*#__PURE__*/React.createElement(Icon, {
        name: "pencil"
      }),
      onClick: function onClick() {
        onEditClick(index);
      }
    }), /*#__PURE__*/React.createElement(Button, {
      auto: true,
      css: {
        p: "0 4px",
        top: "8px"
      },
      size: "xs",
      light: true,
      icon: /*#__PURE__*/React.createElement(Icon, {
        name: "trash"
      }),
      onClick: function onClick() {
        deleteItem(index);
      }
    })));
  }), allowAdd !== false && /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Button, {
    onClick: onAddNewItem,
    icon: /*#__PURE__*/React.createElement(Icon, {
      name: "plus"
    })
  }, "Add new")));
};